import { useQuery } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { createGetParticularOverviewOptions } from '../queries/overviewQueries';
import { errorNotification } from '../reducers/handle-api-status/slice';
import { overview } from '../reducers/overview/slice';

function useOverviewData(pecrId, userInfo, dispatch, t) {
  const [isUserAuthorized, setIsUserAuthorized] = useState(true);

  const { data, isLoading, error } = useQuery(
    createGetParticularOverviewOptions({ pecrId }, { enabled: !!pecrId })
  );

  useEffect(() => {
    if (data) {
      dispatch(overview(data));
      const authorized =
        data?.UserID && Number(data.UserID) === Number(userInfo?.userID);
      setIsUserAuthorized(authorized);
    }
  }, [data, userInfo?.userID, dispatch]);

  useEffect(() => {
    if (error) {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    }
  }, [error, dispatch, t]);

  return {
    overviewData: data,
    isOverviewLoading: isLoading,
    overviewError: error,
    isUserAuthorized,
  };
}
export default useOverviewData;
